import React from 'react';
import { Button, Col, FormLabel, Row } from 'react-bootstrap';
import { Form } from 'formik';
import * as PropTypes from 'prop-types';
import { FormCheckboxField, FormInputField } from '../../common/components/formFields';
import { SiteStatusName } from '../../constants/SiteCreator';
import SiteCreatorEditor from './SiteCreatorEditor';
import ComponentCard from '../../common/components/cards/ComponentCard';

function SiteCreatorForm({ title, isCustom = true }) {
  return (
    <Form noValidate>
      <ComponentCard title={title}>
        <Row>
          <Col xl="4">
            <FormInputField name="title" label="Name" disabled={!isCustom} />
          </Col>
        </Row>
        <Row>
          <Col xl="4">
            <FormInputField
              name="link"
              label="Slug (path to page, e.g. privacy-policy)"
              disabled={!isCustom}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xl="6">
            <FormLabel>Status</FormLabel>
            <FormCheckboxField
              label={SiteStatusName.ACTIVE}
              name="isActive"
              disabled={!isCustom}
            />
          </Col>
        </Row>
        <Row>
          <Col xl="12">
            <FormLabel>Page Content</FormLabel>
            <SiteCreatorEditor name="content" />
          </Col>
        </Row>
        <Row>
          <Col xl="12">
            <Button className="mt-4 float-end rounded-pill btn-primary" type="submit">
              Save
            </Button>
          </Col>
        </Row>
      </ComponentCard>
    </Form>
  );
}

SiteCreatorForm.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SiteCreatorForm;
